export enum UserType {
  SUPER_ADMIN = 'super-admin',
  TENANT_ADMIN = 'tenant-admin',
  NORMAL_USER = 'normal-user',
  READONLY_USER = 'readonly-user',
}

// TODO : Will be removed on phase 2, as its going to be a multitenant system
export const allAvailableGroups = (): string[] => [UserType.SUPER_ADMIN, UserType.NORMAL_USER, UserType.TENANT_ADMIN];

export enum UserEventType {
  UPDATE_PROFILE = 'update_profile',
}

export const NONE = 'None';
